import { Theme } from "@mui/material";
import React from "react";
import { redCandleTheme } from "./Theme";
import { useRCThemeContext } from "./ThemeContext";

export function useSetTheme(theme: Theme) {
  const { setTheme } = useRCThemeContext();
  React.useEffect(() => {
    setTheme(theme);
    return () => {
      setTheme(redCandleTheme);
    };
  }, []);
}
